import type { EvidenceListBlock as EvidenceListBlockType, EvidenceItem } from '../types';
import { BlockEmptyState } from './BlockEmptyState';

// ─────────────────────────────────────────────
// EvidenceListBlock — 证据分类
// Figma: 每个分类 = 分类标题（加粗）+ 列表（绿色圆点 + 文字，URL 显示为蓝色链接）
// ─────────────────────────────────────────────
export function EvidenceListBlock({ block }: { block: EvidenceListBlockType }) {
  const categories = block.categories ?? [];
  // 兼容旧版简单 items 结构（不在标准类型中，做类型断言访问）
  const legacyItems = ((block as unknown as Record<string, unknown>).items as string[] | undefined) ?? [];

  if (categories.length === 0 && legacyItems.length === 0) return <BlockEmptyState label="证据来源" />;

  const isUrl = (val: string | null): val is string =>
    !!val && (val.startsWith('http://') || val.startsWith('https://'));

  if (categories.length > 0) {
    return (
      <div className="flex flex-col gap-5">
        {categories.map((cat, cIdx) => (
          <div key={cIdx} className="flex flex-col gap-2">
            <h5 className="text-[14px] font-medium text-[#262626]">{cat.category}</h5>
            <div className="flex flex-col gap-2">
              {(cat.items as EvidenceItem[]).map((item, iIdx) => (
                <div key={iIdx} className="flex items-center gap-2">
                  {/* 绿色圆点 */}
                  <div className="w-2 h-2 rounded-full bg-[#37E4A6] flex-shrink-0" />
                  {isUrl(item.url) ? (
                    <a
                      href={item.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-[13px] text-[#2563EB] underline leading-[1.5]"
                    >
                      {item.label}
                    </a>
                  ) : (
                    <span className="text-[13px] text-[#737373] leading-[1.5]">{item.label}</span>
                  )}
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    );
  }

  // 旧版兼容
  return (
    <div className="flex flex-col gap-4">
      {legacyItems.map((item, idx) => (
        <div key={idx} className="flex items-start gap-2">
          <div className="w-2 h-2 rounded-full bg-[#37E4A6] flex-shrink-0 mt-[5px]" />
          <span className="text-[13px] text-[#737373] leading-[1.5] list-disc list-inside">{item}</span>
        </div>
      ))}
    </div>
  );
}
